module.exports = __webpack_public_path__ + "static/media/post-to-followers.e7deec28.svg";